import React from "react";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const PhpDevelopers = () => {
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire dedicated PHP developers in India to build secure, scalable, and high-performing web applications. Get cost-effective solutions with expert PHP professionals."/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Dedicated PHP Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-php-developers"/>
<meta property="og:description" content="Hire dedicated PHP developers in India to build secure, scalable, and high-performing web applications. Get cost-effective solutions with expert PHP professionals."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Dedicated PHP Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire dedicated PHP developers in India to build secure, scalable, and high-performing web applications. Get cost-effective solutions with expert PHP professionals."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-php-developers"/>
<title>Hire Dedicated PHP Developers in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className="flex flex-col items-center justify-center p-6">
      <div className=" p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-6">
          <div className="lg:w-3/4 lg:text-left">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Dedicated PHP Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              PHP is one of the most widely used server-side scripting languages
              for web development. With its extensive libraries, frameworks, and
              robust functionality, PHP is ideal for creating dynamic and
              scalable web applications.
              <br />
              <br />
              At Ayanshtech, our experienced PHP developers excel in building
              customized solutions tailored to your business needs. Whether it's
              creating CMS solutions, e-commerce platforms, or APIs, our team
              ensures high-quality deliverables with efficient and secure code.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $10/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a PHP Developer
            </button>
          </div>

          <div className="flex justify-center ">
            <img
              src="\assets\images\headerSection\hireLaravelDev\img3.webp"
              alt="Hire PHP Developers"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center mb-5 p-4">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Our PHP Developer's Areas of Expertise
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          From creating scalable web solutions to integrating robust APIs, our
          PHP experts are proficient in handling projects of varying
          complexities across multiple industries.
        </p>
      </div>

      <div className=" ml-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon11.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Custom PHP Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon12.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">CMS Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon13.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">E-commerce Solutions</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon14.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">API Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon15.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Web Portal Development</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon16.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Third-party Integration</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon17.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Support & Maintenance</p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="/assets/icons/techIcons/icon18.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">Cloud-based PHP Solutions</p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Why Hire PHP Developers from Ayanshtech?
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Gain access to highly skilled PHP developers who ensure cost-effective
          and reliable solutions tailored to your specific project needs.
        </p>
      </div>

      <div className="">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hireLaravelDev\img2.webp"
              alt="Graph on a laptop screen"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="/assets/icons/techIcons/icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Get access to a pool of experienced PHP developers ready to
                  cater to your requirements.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="/assets/icons/techIcons/icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Rigorous vetting ensures only top developers work on your
                  projects.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="/assets/icons/techIcons/icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Our developers provide daily updates during your working
                  hours.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="/assets/icons/techIcons/icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Flexible hiring models tailored to your needs and budget.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      <div id="contact-section">
        {" "}
        <Contact />
      </div>
      <GetInTouch />
    </div>
  </>);
};

export default PhpDevelopers;
